import { Http } from '@/lib/http';

export class LoanApprovalService extends Http {
  constructor() {
    super();
    this.endPoint = 'loan-pro/settings/loan-approvals';
  }

  fetchLoanApprovalSettings() {
    return this.httpClient().get(this.endPoint);
  }

  fetchLoanApprovalSetting(id) {
    return this.httpClient().get(`${this.endPoint}/${id}`);
  }
  updateLoanApprovalLoanTypeSetting(id, updates) {
    return this.httpClient().patch(`${this.endPoint}/loan-type/${id}`, updates);
  }

  updateLoanApprovalLevelSetting(id, updates) {
    return this.httpClient().patch(
      `${this.endPoint}/level-active/${id}`,
      updates
    );
  }

  createLoanApprovalSetting() {
    return this.httpClient().post(this.endPoint);
  }
}
